export const NEIGHBOURHOOD_PERKS_CAROUSEL_SLIDE_DURATION = 15_000;

export const NEIGHBOURHOOD_PERK_DESCRIPTION_LINES = 2;
